import { render, staticRenderFns } from "./renewAdd.vue?vue&type=template&id=8a64b87a&scoped=true&"
import script from "./renewAdd.vue?vue&type=script&lang=js&"
export * from "./renewAdd.vue?vue&type=script&lang=js&"
import style0 from "./renewAdd.vue?vue&type=style&index=0&id=8a64b87a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a64b87a",
  null
  
)

export default component.exports